import BodyType from 'owa-service/lib/contract/BodyType';
import { ComposeEditorType } from './schema/ComposeEditorType';
import { EditorSupportViewState } from './schema/EditorSupportViewState';
import { PreferredEditorMap } from './schema/PreferredEditorMap';
import { defaultPreferredEditorTypes } from './preferredEditorTypes';

/**
 * Get the active editor type for the viewState's bodytype and preferences.
 * Does so in a really paranoid way
 *
 * Swallows errors and reports them in setTimeout so they will surface an exception dialog,
 * but will not unmount the app if called during render.
 */
export function getActiveEditorType(viewState: EditorSupportViewState): ComposeEditorType {
    if (viewState.bodyType == null) {
        setTimeout(() => {
            throw new Error(
                `viewState.bodyType was nullish (${
                    viewState.bodyType
                }). Please report this + what you were doing before it happened.`
            );
        }, 0);
    }
    const bodyType: BodyType = viewState.bodyType || 'HTML';

    if (viewState.preferredEditors == null) {
        setTimeout(() => {
            throw new Error(
                `viewState.preferredEditors was nullish (${
                    viewState.preferredEditors
                }). Please report this + what you were doing before it happened.`
            );
        }, 0);
    }
    const preferredEditors: PreferredEditorMap = viewState.preferredEditors || {
        ...defaultPreferredEditorTypes,
    };

    try {
        return preferredEditors[bodyType];
    } catch (e) {
        setTimeout(() => {
            throw e;
        }, 0);
        return ComposeEditorType.RoosterHTML;
    }
}

export default getActiveEditorType;
